import React, { ReactNode } from 'react';
import { AppShell, Group } from '@mantine/core';
import ServerStatus from './ServerStatus';
import LanguageSelector from './LanguageSelector';

interface LayoutProps {
  children: ReactNode;
}

/**
 * Main application layout component
 * Includes header with server status and wraps content
 */
const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <AppShell
      header={{ height: 60 }}
      padding={0}
    >
      <AppShell.Header>
        <Group h="100%" px="md" justify="space-between">
          <div className="text-xl font-bold">Game Master Tool</div>
          <Group gap="md">
            <LanguageSelector />
            <ServerStatus />
          </Group>
        </Group>
      </AppShell.Header>
      
      <AppShell.Main className="h-[calc(100vh-60px)]">
        {children}
      </AppShell.Main>
    </AppShell>
  );
};

export default Layout; 